// Fixed, generic-industry reason codes for QC rejection line items — deliberately not a
// database-backed master (no company would need to customize this list day one), matching how
// this codebase already treats other small fixed-vocabulary fields (e.g. Notification.Type).
// ReasonCode (the `value` here) is what's actually persisted on QcRejection.ReasonCode; `label` is
// display-only and can be re-worded/re-ordered freely without touching stored data.
export interface QcRejectionReason {
  value: string;
  label: string;
}

export const QC_REJECTION_REASONS: QcRejectionReason[] = [
  { value: 'Damaged', label: 'Damaged / Physical Defect' },
  { value: 'DimensionalDeviation', label: 'Dimensional Deviation' },
  { value: 'WrongMaterial', label: 'Wrong Material / Mismatch' },
  { value: 'ShortQuantity', label: 'Short Quantity / Shortage' },
  { value: 'Contamination', label: 'Contamination / Foreign Material' },
  { value: 'ExpiredNearExpiry', label: 'Expired / Near Expiry' },
  { value: 'DocumentationMismatch', label: 'Documentation Mismatch' },
  { value: 'BelowSpecification', label: 'Below Specification / Standard' },
  { value: 'PackagingDefect', label: 'Packaging Defect' },
  { value: 'FunctionalFailure', label: 'Functional / Performance Failure' },
  { value: 'Other', label: 'Other' },
];
